import request from '@/utils/request';

// 列表
export function ApiZoneList(query) {
  return request({
    url: '/lock/gmwebapi/communityList',
    method: 'get',
    params: query,
  });
}

// 列表 - 无分页
export function ApiZoneNoPageList(query) {
  return request({
    url: '/lock/gmwebapi/communityDropDown/' + query,
    method: 'get',
  });
}

// 新增
export function ApiZoneAdd(query) {
  return request({
    url: '/lock/gmwebapi/addCommunity',
    method: 'post',
    data: query,
  });
}

// 编辑
export function ApiZoneEdit(query) {
  return request({
    url: '/lock/gmwebapi/updateCommunity',
    method: 'put',
    data: query,
  });
}

// 删除
export function ApiZoneDelete(query) {
  return request({
    url: '/lock/gmwebapi/deleteCommunity/' + query,
    method: 'delete',
  });
}